import { render, staticRenderFns } from "./orderIng.vue?vue&type=template&id=29b5a265&"
import script from "./orderIng.vue?vue&type=script&lang=js&"
export * from "./orderIng.vue?vue&type=script&lang=js&"
import style0 from "./orderIng.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports